import type { UnknownAction } from 'redux';

export type SidebarActions =
  | OpenSidebarAction
  | CloseSidebarAction
  | ToggleSidebarAction
  | EnableRailSidebarAction
  | DisableRailSidebarAction;

interface OpenSidebarAction extends UnknownAction {
  type: 'SIDEBAR:OPEN';
}

interface CloseSidebarAction extends UnknownAction {
  type: 'SIDEBAR:CLOSE';
}

interface ToggleSidebarAction extends UnknownAction {
  type: 'SIDEBAR:TOGGLE';
}

interface EnableRailSidebarAction extends UnknownAction {
  type: 'SIDEBAR:ENABLE_RAIL';
}

interface DisableRailSidebarAction extends UnknownAction {
  type: 'SIDEBAR:DISABLE_RAIL';
}

export const openSidebar = (): OpenSidebarAction => ({ type: 'SIDEBAR:OPEN' });
export const closeSidebar = (): CloseSidebarAction => ({ type: 'SIDEBAR:CLOSE' });
export const toggleSidebar = (): ToggleSidebarAction => ({ type: 'SIDEBAR:TOGGLE' });
export const enableSidebarRail = (): EnableRailSidebarAction => ({ type: 'SIDEBAR:ENABLE_RAIL' });
export const disableSidebarRail = (): DisableRailSidebarAction => ({
  type: 'SIDEBAR:DISABLE_RAIL',
});
